import {Component, OnInit} from '@angular/core';
import {Validators, FormGroup, FormBuilder} from "@angular/forms";
import {AuthService} from "../shared/security/auth.service";
import {Router} from "@angular/router";
import {ModalWindowComponent} from "../modal-window/modal-window.component";
import {ViewChild} from "@angular/core";
import {set as setCookie, get as getCookie, remove as removeCookie} from 'es-cookie';
import {TranslateService} from "@ngx-translate/core";
import {sleepMilliseconds} from "../shared/util/sleep-util";
import {AgendaItem} from "../shared/model/agendaItem";


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  form: FormGroup;
  isLoggedIn: boolean = false;
  authInfo: AuthService;
  headerMessage: string;
  loginError: boolean = false;
  numberOfTries: number = 0;

  stLoginName: string;
  stPassword: string;

  public booleanValues = [
    {value: false, display: 'Nee'},
    {value: true,  display: 'Ja'}
  ];
  setCookie: boolean;        // indicates if cookie with username/password will be set (unsafe)

  constructor(private fb: FormBuilder, private authService: AuthService,
              private router: Router, private translate: TranslateService) {

    this.authInfo = authService;

    this.stLoginName = getCookie("st-login-name");
    this.stPassword  = getCookie("st-pw");

    //console.log("Cookie name    : " + this.stLoginName);
    //console.log("Cookie password: " + this.stPassword);

    if(this.stLoginName === undefined) {
      this.stLoginName = "";
    }
    if(this.stPassword === undefined) {
      this.stPassword = "";
      this.setCookie = false;
    } else {
      this.setCookie = true;
    }

    this.form = this.fb.group({
      email: [this.stLoginName, Validators.required],
      password: [this.stPassword, Validators.required]
    });
  }

  ngOnInit() {
    //console.log(`login naam: ${this.stLoginName}`);
    //console.log(`wachtwoord: ${this.stPassword}`);

    this.numberOfTries = 0;
    this.isLoggedIn = this.authInfo.isStillLoggedIn();

    if(this.isLoggedIn) {
      this.headerMessage = " Logout:";
    } else {
      this.headerMessage = " Login:";
    }
  }

  public getTranslation(key: string) {
    let str="";
    this.translate.get(key).subscribe(value => {str = value});
    return str;
  }


  login() {
    const formValue = this.form.value;
    const loginName = formValue.email.trim().toLowerCase();

    this.isLoggedIn = this.authService.login(loginName, formValue.password);
    this.numberOfTries++;

    if(this.isLoggedIn) {
      this.loginError = false;
      setCookie("st-login-name", loginName, {expires: 10000});
      if(this.setCookie) {
        setCookie("st-pw", formValue.password, {expires: 10000});
      }
      //this.router.navigate(['home']);
    } else {
      this.loginError = true;
    }

    if(!this.setCookie) {
      removeCookie("st-pw");
    }

  }

  close() {
    if(this.isLoggedIn) {
      this.router.navigate(['lighting']);
    }
  }

  toggleSetCookie() {
    this.setCookie = !this.setCookie;
    if ( !this.setCookie ) {  // no cookies: delete them!
      removeCookie("st-login-name");
      removeCookie("st-pw");
    }
  }

}
